module.exports = __webpack_public_path__ + "img/pre.e76b729a.svg";